/*
 * @Author: wanglongx
 * @Date: 2019-08-28 12:28:22
 * @LastEditors: bbq
 * @LastEditTime: 2021-01-06 11:21:45
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginDatePicker from 'bee-datepicker';
// import { moment } from '@platform/api'
import moment from 'moment';
import { HotKeys } from 'react-hotkeys';
import { isArray, isString } from 'util';
import { getDateFunNode, checkFuntionValue, getTimeFunctionLabel, setMultiLang } from './dateFunction';
import { locale, localeLang, config, findParentTd, getSysFieldid, PubSub, keyboard, isIE, setElementFocusInIE, getMultiLang, getDatetimeFormat } from '@platform/api';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-au';
import Tooltip from '../Tooltip';

require('./index.less');
require('bee-datepicker/build/DatePicker.css');

const { isKeyboard, isArrowKeyDown, KeyCode, isComboKeyboard } = keyboard;

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            json: {},
            // add by bbqin 添加value控制
            value: this.props.value,
            hasCloseBtn: false,
        };
    }

    UNSAFE_componentWillMount() {
        let { defaultValue, value, isFun, timeFun } = this.props;

        if (defaultValue || value) {
            this.setState({ hasCloseBtn: true });
        }
        if (isFun && timeFun) {
            this.setState({ hasCloseBtn: true });
        }
        let callback = json => {
            setMultiLang(json);
            this.setState({ json, localeLang });
        };

        getMultiLang({ moduleId: ['common', 'page_search'], callback });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((nextProps.value && !this.state.hasCloseBtn) || (nextProps.isFun && nextProps.timeFun)) {
            this.setState({ hasCloseBtn: true });
        }
        this.setState({
            // 取上一次的狀態  by bbqin
            // open: nextProps.datepickerOpen === undefined ? this.state.open : nextProps.datepickerOpen,
            value: nextProps.value,
        });
    }

    componentDidMount() {
        // 做下自動聚焦
        let { tableOpen, autoFocus } = this.props;
        if (autoFocus && this.dateInputWrap && tableOpen) {
            let elem = this.dateInputWrap.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // 做下自動聚焦
        let { tableOpen, autoFocus } = this.props;
        if (autoFocus && this.dateInputWrap && tableOpen && this.changeValFromPanelSelect === false) {
            let elem = this.dateInputWrap.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }

    }

    componentWillUnmount() {
        this.dateInput = null;
        this.dateInputWrap = null;
        this.clearOpenPanelToken && PubSub.unsubscribe(this.clearOpenPanelToken);
    }

    onClick = e => {
        let props = this.props;
        props.onClick && props.onClick(e, this.dateInput);
        // this.setState({
        // 	open: this.props.datepickerOpen == undefined ? true : this.state.open
        // });
        // 添加一个状态来区分是否时鼠标和tab操作  by bbqin
        this.clicked = true;
    };

    // 添加 onOpenChange  来控制关闭时重新聚焦  --bbqin
    onOpenChange = (isOpen, value, formatValue) => {
        // 记录一下open状态给 其他人用
        this.open = isOpen;

        let props = this.props;
        // 目前自动聚焦还有些问题  主要是点击其他表单元素时应该聚焦为其他元素
        if (isOpen === false && this.dateInputWrap) {
            let elem = this.dateInputWrap.querySelector('input'); // 获取到底层的input
            isIE() ? setElementFocusInIE(elem) : elem && elem.focus();
        }
        // 关闭之后认为  clicked为false  加这个属性时为了不影响原来的鼠标鼠标操作
        if (isOpen === false) {
            this.clicked = false;
            // 改变一下状态  避免状态被记录
            // this.setState({
            // 	open: false
            // });
        }
        // if (isOpen === true) {
        //     // 改变一下状态  避免状态被记录
        //     this.setState({
        //         open: true
        //     });
        // }
        // 这里需要调用一下外部的编辑前事件   目前的问题是抛出的对象和click中不同
        // if (isOpen === true && !this.clicked) {
        // 	props.onClick && props.onClick(this.dateInput, this.dateInput);
        // }
        if (isOpen) {
            props.onClick && props.onClick(this.dateInput, this.dateInput);
        }

        let escKeyDown = isKeyboard('esc', window.event);
        //目前按ctrl|esc键键关闭时会触发表格onBlur事件因此在这儿加一个控制，如果是ctrl|esc触发关闭不去调用表格的blur事件
        props.onOpenChange &&
            props.onOpenChange(isOpen, value, formatValue, {
                ctrlKeyDown: this.ctrlKeyDown,
                escKeyDown,
            });

        // 发布一个清除事件 用于快捷键关闭 by bbqin
        if (isOpen) {
            this.clearOpenPanelToken = PubSub.subscribe('clearOpenPanel', () => {
                if (this.dateInputWrap) {
                    let elem = this.dateInputWrap.querySelector('input'); // 获取到底层的input
                    console.log('clearOpenPanel subscribe ');
                    elem && elem.click();
                }
                // this.dateInput.setState({open: false})
            });
        } else {
            PubSub.unsubscribe('clearOpenPanel');
        }
        this.ctrlKeyDown = false;
    };

    //添加x按钮，清空输入框的日期
    clearValue = () => {
        const { formClear, onOpenChange, onClose } = this.props;
        let beforeEventResult = this.props.onClick && this.props.onClick({}, {}, true);
        if (beforeEventResult && typeof beforeEventResult.then === 'function') {
            beforeEventResult.then(res => {
                if (res) {
                    let { disabled } = this.props;
                    this.setState({
                        hasCloseBtn: false,
                        value: '',
                    });
                    if (disabled !== true) {
                        //编辑态的时候点击才清空显示的日期
                        this.onChange(null);
                        // fix NCC-93171
                        onClose?.('');
                        formClear && onOpenChange && onOpenChange(false);
                    }
                }
            });
        } else {
            let { disabled } = this.props;
            this.setState({
                hasCloseBtn: false,
                value: '',
            });
            if (disabled !== true) {
                //编辑态的时候点击才清空显示的日期
                this.onChange(null);
                // fix NCC-93171
                onClose?.('');
            }
        }
    };

    onChange = (val, MultiTZ, format) => {
        const { disabled } = this.props;
        if (MultiTZ) {
            this.props.onChange && this.props.onChange(val);
        } else {
            if (isArray(format)) {
                format = format[0];
            }
            // this.props.onChange && this.props.onChange(!val ? val : val.format("YYYY-MM-DD"));
            this.props.onChange && this.props.onChange(!val ? val : val.format(format));
        }
        if (disabled !== true && !val) {
            this.setState({ hasCloseBtn: false });
        }
    };

    // keyDown
    keyDownHandler = e => {
        let { onEnter, hotKeyWithArrow, onBlur, renderInTable, onKeyDown, arrowKeyDownEnable } = this.props;

        onKeyDown && onKeyDown(e, this.dateInputWrap, this.open);

        // enter 键
        if (isKeyboard('enter', e) && this.open !== true) {
            // 不加阻止默認事件  會導致
            e.stopPropagation();
            e.preventDefault();
            let value = this.state.value;
            if (checkFuntionValue(value)) {
                value = '';
            }
            onBlur && onBlur(value);
            onEnter &&
                onEnter({
                    e,
                    target: this.dateInputWrap,
                    itemType: config.hotKeyDatePicker,
                });
        }

        //按下ctrl键
        if (renderInTable && isKeyboard('ctrl', e)) {
            this.ctrlKeyDown = true;
        }

        if (renderInTable && isArrowKeyDown(e) && this.open !== true && !arrowKeyDownEnable) {
            e.stopPropagation();
            e.preventDefault();
            let value = this.state.value;
            if (checkFuntionValue(value)) {
                value = '';
            }
            onBlur && onBlur(value);

            hotKeyWithArrow &&
                hotKeyWithArrow({ e, target: this.dateInputWrap, itemType: config.hotKeyDatePicker });
        }

        if (isArrowKeyDown(e) && this.open === true && !arrowKeyDownEnable) {
            this.changeValFromPanelSelect = true;
        } else {
            this.changeValFromPanelSelect = false;
        }

    };

    inputWrapperKeyDown = e => {
        let { value } = this.props;
        value = this.state.value;
        if (checkFuntionValue(value)) {
            value = '';
        }
        let { renderInTable, onEnter } = this.props;
        // tab键
        let isTab = isKeyboard('tab', e);
        //如果是事件源是日期面板中的input就不做处理
        if (renderInTable && e.target.classList.contains('rc-calendar-input') && isTab) {
            this.isPanelTrigger = true;
            e.stopPropagation(); // 避免冒泡到上层 触发事件
            return;
        }

        // 判断是否键下tab键和shift 键  bbqin
        if ((isTab && e.shiftKey) || isTab) {
            setTimeout(() => {
                // 实际情况下发现 不添加timeout shift+tab 无法跳转
                // 猜测 可能是 原生shift+tab 事件与当前事件有了执行顺序
                this.props.onBlur && this.props.onBlur(value);
            }, 0);
        }

        if (renderInTable && isKeyboard('enter', e)) {
            let target = findParentTd(this.dateInputWrap);
            onEnter && onEnter({ target });
        }
    };

    render() {
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            value,
            showStar,
            onChange,
            MultiTZ = false,
            showTimeFunction,
            placeholder,
            autoFocus,
            disabled,
            className,
            fieldid,
            dropdownClassName,
            dateInputPlaceholder,
            onClick,
            renderInTable,
            noDataFormat = false, //数据格式转换开关
            ...others
        } = this.props;
        switch (localeLang) {
            case 'simpchn':
                moment.locale('zh-cn');
                break;
            case 'english':
                moment.locale('en');
                break;
            case 'tradchn':
                moment.locale('zh-tw');
                break;
            default:
                moment.locale('zh-cn');
        }
        let defaultFormat = isArray(format) ? format[0] : format;
        let finalFormat = defaultFormat;
        // 添加了inputShowValue属性 ，外层输入框的日期格式
        let inputShowValue = '';
        if (value && !noDataFormat && !(String(value).startsWith("#"))) { //---SUPPORT-509814
            finalFormat = getDatetimeFormat(defaultFormat);
            let localLocale = moment(value);
            localLocale.locale('en');//设置局部moment对象，将语种设置为英文
            inputShowValue = localLocale.format(finalFormat);
        }

        inputShowValue = isString(value) && value.indexOf('#') > -1 ? "" : inputShowValue;

        let { hasCloseBtn, json } = this.state;

        if (this.props.disabled) {
            className = className ? className + ' datepicker-wrapper-disabled' : 'datepicker-wrapper-disabled';
        }
        // 使用状态上的value值来记录  by bbqin
        value = this.state.value;
        let functionValue = value || '';
        if (checkFuntionValue(value)) {
            value = '';
            placeholder = '';
        }

        if (getSysFieldid(fieldid)) {
            dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
        }
        return (
            <HotKeys
                className="hotkeys-datepicker-wrapper"
                keyMap={{ datepickerClear: 'del' }}
                handlers={{
                    datepickerClear: () => {
                        // 调用内部的状态进行清空  by bbqin
                        this.setState(
                            { value: '' },
                            () => {
                                // 调用外部change事件进行清空
                                if (MultiTZ) {
                                    this.props.onChange && this.props.onChange('');
                                } else {
                                    this.props.onChange && this.props.onChange('');
                                }
                            },
                        );
                    },
                }}
            >
                <div
                    className={`u-form-control-wrapper ${className}`}
                    // 工作桌面需要移除
                    // onClick={(e) => {
                    // 	e.stopPropagation();
                    // }}
                    ref={dom => {
                        this.dateInputWrap = dom;
                    }}
                    onKeyDown={this.inputWrapperKeyDown}
                    onBlur={e => {
                        let { renderInTable } = this.props;
                        //如果是事件源是日期面板中的input就不做处理  避免关闭弹窗
                        if (renderInTable && e.target.classList.contains('rc-calendar-input') && this.isPanelTrigger) {
                            e.stopPropagation();
                        }
                        this.isPanelTrigger = false;
                    }}

                    onKeyUp={e => {
                        let { renderInTable } = this.props;
                        if (this.ctrlKeyDown && isKeyboard('ctrl', e) && renderInTable && !isComboKeyboard(e)) {
                            let elem = this.dateInputWrap.querySelector('input');
                            elem && elem.click();
                        }
                        this.ctrlKeyDown = false;
                    }}
                >
                    {showStar ? <span className="datepicker-input-required-tag">*</span> : ''}
                    <div
                        style={{ position: 'relative' }}
                        className="nc-datepicker-input-wrap"
                        fieldid={getSysFieldid(fieldid)}
                    >
                        <OriginDatePicker
                            // 解决弹开面板时  按tab键关闭了面板的问题
                            inputTabKeyOpen={true}
                            animation=""
                            // 加一个唯一class
                            className={`nc-input DatePicker ${className}`}
                            dropdownClassName={dropdownClassName + ' nc-calendar'}
                            format={format}
                            locale={locale}
                            value={value ? moment(value) : ''}
                            showToday={false}
                            placeholder={placeholder}
                            disabled={disabled}
                            // disabledDate={(current, next) => {
                            // 	this.props.disabledDate && this.props.disabledDate(current, next, moment);
                            // }}
                            inputShowValue={inputShowValue}
                            renderError={() => (
                                <Tooltip
                                    visible={true}
                                    className="datepicker-tooltip"
                                    placement="top"
                                    overlay={`${json['common-0004']}：${dateInputPlaceholder || 'YYYYMMDD'}`}
                                >
                                    <span style={{ position: 'absolute', left: '125px' }} />
                                </Tooltip>
                            )}
                            ref={dateInput => {
                                this.dateInput = dateInput; // 获取到组件对象 -- bbqin
                            }}
                            renderIcon={this.props.renderIcon}
                            onChange={val => {
                                this.onChange(val, MultiTZ, format);
                            }}
                            renderFooter={() => getDateFunNode(functionValue, onChange, showTimeFunction, this.props.hiddenFunList)}
                            {...others}
                            // onClick={this.onClick}
                            // open={this.state.open}
                            onOpenChange={this.onOpenChange.bind(this)}
                            dateInputPlaceholder={dateInputPlaceholder || 'YYYYMMDD'}
                            outInputKeydown={this.keyDownHandler}
                            onKeyDown={this.keyDownHandler}
                            onDateInputBlur={() => {
                                /**
                                 * 还需要进一步解决的问题
                                 * 是否要转时区
                                 * format类型是日期 时间 的需要兼容处理
                                 * 录入完成？能否执行onChange事件
                                 */
                                // let newDate = repleAndCheckDate(v);
                                // if(newDate){
                                // 	this.setState({
                                // 		value: moment(newDate)
                                // 	})
                                // }
                            }}
                        // onBlur={() => {
                        //     console.log("datepicker onblur trigger");
                        // }}
                        //添加属性,去掉内层输入框---剩余功能：面板下移到录入框下面
                        //showDateInput={false}
                        //style={{'top':35}}
                        />
                        {hasCloseBtn && (<i
                            className={"nc-datepicker-del-i iconfont icon-qingkong" + (disabled ? ' icon-hidden' : '')}
                            onClick={() => {
                                this.clearValue();
                            }}
                        />)}
                        {getTimeFunctionLabel(functionValue, showTimeFunction)}
                    </div>
                </div>
            </HotKeys>
        );
    }
}
DatePicker.defaultProps = {
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
    showClose: false,
};

export default DatePicker;
